/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Setpoint_Bound_Min_Below_MaxInputs */



/**
* | output |
* | --- |
* | "The minimum bound must be below the maximum bound" |
*
* @param {Air_Handler_Unit_Setpoint_Bound_Min_Below_MaxInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_setpoint_bound_min_below_max = /** @type {((inputs?: Air_Handler_Unit_Setpoint_Bound_Min_Below_MaxInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Setpoint_Bound_Min_Below_MaxInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The minimum bound must be below the maximum bound")
	return /** @type {LocalizedString} */ ("La borne minimum doit être inférieure à la borne maximum")
});